import { Stack, Typography } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { TopNavigationInvestor } from '../../@biz_investor/navigation-top/TopNavigationInvestor'
import { TopNavigationOwner } from '~/@biz_owner/navigation-top/TopNavigationOwner'
import PhoneSvg from '~/@ui/_sharedSvgs/ui/Phone.svg?react'
import MessageSvg from '~/@ui/_sharedSvgs/ui/Message.svg?react'
import ArrowRightWhiteSvg from '~/@ui/_sharedSvgs/ui/ArrowRightWhite2.svg?react'
import { useCurrentUserData } from '~/@biz_account/useCurrentUserData/useCurrentUserData'

export const HelpCenterPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useCurrentUserData()

  const isInvestorRoute = location.pathname.includes('/investor/')
  const isOwnerRoute = location.pathname.includes('/vlastnik/')

  const navigateToCallMe = () => {
    const basePath = isInvestorRoute ? '/investor' : '/vlastnik'
    navigate(`${basePath}/help-center/call-me`)
  }

  const navigateToContactForm = () => {
    const basePath = isInvestorRoute ? '/investor' : '/vlastnik'
    navigate(`${basePath}/help-center/contact-form`)
  }

  return (
    <Stack className="min-h-screen bg-zBlack200">
      {isInvestorRoute && <TopNavigationInvestor user={user} />}
      {isOwnerRoute && <TopNavigationOwner user={user} />}

      <Stack className="max-w-[768px] self-center gap-3.5 px-6 pt-6 pb-28">
        <Typography className="text-base font-bold text-zWhite200">
          Potrebujete poradiť? Neváhajte sa na nás obrátiť s akoukoľvek
          požiadavkou. Vyberte si z dostupných kontaktov.
        </Typography>

        <Typography className="text-xl font-bold text-zWhite200 mt-4">
          Ako nás chcete kontaktovať?
        </Typography>

        <Stack
          className="flex-row items-center gap-4 p-4 bg-zBlack300 rounded-4d cursor-pointer"
          onClick={navigateToCallMe}>
          <Stack className="w-[44px] h-[44px] justify-center items-center bg-zGrey300 rounded-full">
            <PhoneSvg />
          </Stack>

          <Stack>
            <Typography className="text-3d font-medium text-zWhite200">
              Zavolajte mi
            </Typography>
            <Typography className="text-3d font-medium text-zGrey400">
              {`Na ${user?.phoneNumber || '...'}`}
            </Typography>
          </Stack>

          <ArrowRightWhiteSvg className="ml-auto" />
        </Stack>

        <Stack
          className="flex-row items-center gap-4 p-4 bg-zBlack300 rounded-4d cursor-pointer"
          onClick={navigateToContactForm}>
          <Stack className="w-[44px] h-[44px] justify-center items-center bg-zGrey300 rounded-full">
            <MessageSvg />
          </Stack>

          <Stack>
            <Typography className="text-3d font-medium text-zWhite200">
              Kontaktný formulár
            </Typography>
            <Typography className="text-3d font-medium text-zGrey400">
              Napíšte nám
            </Typography>
          </Stack>

          <ArrowRightWhiteSvg className="ml-auto" />
        </Stack>

        <Stack className="gap-6 mt-12">
          <Typography className="text-base font-bold text-zWhite200">
            Kontakt na zákaznícku podporu
          </Typography>

          <Stack>
            <Typography className="text-base font-bold text-zGrey400">
              Tel. číslo
            </Typography>
            <Typography className="text-base font-bold text-zWhite200">
              +421 910 344 231
            </Typography>
          </Stack>

          <Stack>
            <Typography className="text-base font-bold text-zGrey400">
              Email
            </Typography>
            <Typography className="text-base font-bold text-zWhite200">
              podpora@bonaship.sk
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  )
}
